const { createContext } = require("react");

export const StateModalContext = createContext();
